import { Assert } from '@team/assert';

/**
 * > ⚠️ Не очень хорошо работает с длинными дробями
 */
export function getFractionLength(value: number): number {
  const [, fraction] = value.toString().split('.');

  if (Assert.isUndefined(fraction)) {
    return 0;
  }

  return fraction.length;
}
